// shared/src/schemas/macro-prediction-observable.ts
// Zod schema for `macro_prediction_observables` table (0002:33-42).
// 8 columns. N rows per macro_predictions row (≥3 per design doc §M-stage
// pattern coherence threshold: ≥3 observables, ≥2 asset classes).

import { z } from 'zod';
import { coercedEnum, coerceDirection } from '../resolvers/llm-enum-coerce.js';

// 2026-05-29 — coerced (was bare z.enum). This enum validates the LLM-emitted
// observable direction at the macro_predictions boundary (macro-prediction-emit
// .ts:69, run inside partitionMacroPredictionsByZodValidity). The resolver chain
// already canonicalizes `indicator` + `prediction_mode` but never case-folded
// `direction` — so 'Up'/'bullish'/'rising' hard-failed. coerceDirection maps to
// canonical; unknown still fail-louds. No-op on DB read-back (always canonical).
export const MacroPredictionObservableDirectionEnum = coercedEnum(['up', 'down', 'flat'], coerceDirection);

export const MacroPredictionObservableSchema = z.object({
  id:             z.string(),
  prediction_id:  z.string(),
  indicator:      z.string(),                                       // e.g. 'DXY', 'TLT', 'VIX'
  baseline_value: z.number(),
  direction:      MacroPredictionObservableDirectionEnum,
  change_pct:     z.number(),
  change_ci_low:  z.number(),
  change_ci_high: z.number(),
  // World-state Phase 1 (2026-05-25) — migration 0012 added with NOT NULL
  // DEFAULT 0. INTEGER (0|1) per SQLite convention. LLM marks 3-5 most
  // diagnostic observables across all predictions per brief (rule 17 in
  // m-analyst SYSTEM, Component 6). Drives ZoneTheBet
  // WorldStateComparison filter `WHERE is_headline=1`.
  is_headline:    z.number().int().min(0).max(1),
});

export type MacroPredictionObservable = z.infer<typeof MacroPredictionObservableSchema>;
